import { ClientChatCase } from "@/api/chatcase.js";
const state = {
  preventLeaveRoom: false,
  messageCenter: [],
  showRoomInfos: true,
  chatcase: [],
  idleTime: 0,
};

const actions = {
  receiveMessage({ commit }, payload) {
    commit("updateMessage", payload);
  },
  initChatCase({ state }) {
    let params = {
      date: [],
      pageRequestParameter: {
        isReturnAllDataAndNoPage: true,
        targetPage: 0,
        showCount: 0,
      },
    };
    ClientChatCase.List(params).then((res) => {
      state.chatcase = res.data.data;
    });
  },
};

const mutations = {
  toggleRoomInfos() {
    state.showRoomInfos = !state.showRoomInfos;
  },
  // 初始化通知中心
  setMessageCenter(state, payload) {
    state.messageCenter = payload;
  },
  updateMessage(state, payload) {
    let isUpdate = state.messageCenter.find((m) => {
      return m.id == payload.id;
    });
    if (isUpdate) {
      state.messageCenter.forEach((m, idx) => {
        if (m.id == payload.id) {
          state.messageCenter[idx].status = payload.status;
        }
      });
    } else {
      state.messageCenter.unshift(payload);
    }
  },
  readAllMessageCenter(state) {
    state.messageCenter.forEach((m) => {
      m.isRead = true;
    });
  },
  togglePreventLeaveRoom(state, payload) {
    state.preventLeaveRoom = payload;
  },
  setIdleTime(state, payload) {
    state.idleTime = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
